import concedidoIcon from '../../../assets/concedido.png';
import naoConcedidoIcon from '../../../assets/naoConcedido.png';
import emAnaliseIcon from '../../../assets/em-analise.png';
import confirmadoIcon from '../../../assets/soli check blue.png';

export const RELATORIOS_CONCESSAO = {
  'campos-solicitados': { titulo: 'Campos Solicitados' },
};

export const STATUS_LEGENDA = {
  PENDENTE: { rotulo: 'Para análise', icone: emAnaliseIcon },
  CONCEDIDO: { rotulo: 'Concedido', icone: concedidoIcon },
  CONFIRMADA: { rotulo: 'Confirmado', icone: confirmadoIcon },
  RECUSADO: { rotulo: 'Não concedido', icone: naoConcedidoIcon },
};

export const STATUS_FILTRO = [
  { valor: 'PENDENTE', rotulo: 'Para análise' },
  { valor: 'CONCEDIDO', rotulo: 'Concedido' },
  { valor: 'CONFIRMADA', rotulo: 'Confirmado' },
  { valor: 'RECUSADO', rotulo: 'Não concedido' },
];

export const CAMPOS_ORDENACAO = [
  { valor: 'criadoEm', rotulo: 'Data da solicitação' },
  { valor: 'area', rotulo: 'Especialidade' },
  { valor: 'status', rotulo: 'Status' },
  { valor: 'alunos', rotulo: 'Nº de alunos' },
  { valor: 'horas', rotulo: 'Nº de horas' },
  { valor: 'totalHoras', rotulo: 'Total de horas' },
];

export const FILTROS_DO_PAINEL = [
  'status',
  'areaCursoId',
  'tipoAtividade',
  'unidadeAssistencialId',
  'periodoInicio',
  'periodoFim',
];
